import styled from 'styled-components';

interface MobileWidgetCardsStyledProps {
    show: boolean;
}

export const MobileWidgetCardsStyled = styled.div<MobileWidgetCardsStyledProps>`
    height: ${({ show }) => (show ? 'auto' : '0px')};
    opacity: ${({ show }) => (show ? '1' : '0')};
    transition: height 1s ease, opacity 1s ease;

    h3 {
        color: var(--color-label-primary);
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 12px;
    }

    position: relative;

    .arrow-left, .arrow-right {
        position: absolute;
        bottom: -14px;
    }

    .arrow-left {
        left: 0;
    }

    .arrow-right {
        right: 0;
    }
`;

export const MobileWidgetCardsContainerStyled = styled.div`
    display: flex;
    gap: 8px;
    overflow-x: scroll;
    padding-bottom: 22px;

    &.mobile {
        padding: 0 16px;
        margin: 0 -16px;
    }

    > div {
        flex-shrink: 0;
        flex-grow: 0;
    }
`;

export const MobileWidgetCardsSeeAllContainerStyled = styled.div`
    display: flex;
    height: 48px;
`;

export const MobileWidgetCardsSeeAllStyled = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 0 8px 12px;
    cursor: pointer;
    
    .arrow-icon {
        fill: var(--color-label-primary);
        height: 16px;
        width: 16px;
    }
`;

export const MobileWidgetCardsHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    gap: 12px;
`;
